'use strict';

exports.__esModule = true;
exports.SvgIcon = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svgIcon = require('../../src/styles/svg-icon.scss');

var _svgIcon2 = _interopRequireDefault(_svgIcon);

var _constants = require('../utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIcon = exports.SvgIcon = function SvgIcon(_ref) {
    var className = _ref.className,
        icon = _ref.icon;

    var href = _constants.PATH_TO_SPRITE + '#' + icon;

    return _react2.default.createElement(
        'svg',
        { className: _svgIcon2.default['svg-icon'] + ' ' + (className || '') },
        _react2.default.createElement('use', { xlinkHref: href })
    );
};

SvgIcon.displayName = 'SvgIcon';

SvgIcon.defaultProps = {
    className: '',
    icon: ''
};


// WEBPACK FOOTER //
// ./components/svg-icon/lib/components/svg-icon.js